module.exports = __webpack_public_path__ + "static/media/info.e219ac3d.svg";